import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 3h4v4h-4z","key":"svg-0"}],["path",{"d":"M3 17h4v4h-4z","key":"svg-1"}],["path",{"d":"M17 17h4v4h-4z","key":"svg-2"}],["path",{"d":"M7 17l5 -4l5 4","key":"svg-3"}],["path",{"d":"M12 7l0 6","key":"svg-4"}]]

const IconHierarchy2 = createReactComponent('outline', 'hierarchy-2', 'Hierarchy2', __iconNode);

export default IconHierarchy2;